export default __webpack_public_path__ + "static/media/img-ovato-nfts-new.c50bbcbb.png";